import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import MenuItem from '@mui/material/MenuItem';

import TextField from 'cityads-v3/components/TextField/TextField';

import {
  getChannels
} from 'cityads-v3/actions/channels';

export const CHANNEL_CHANGE_REASON_AUTOSELECT = 'autoselect';
export const CHANNEL_CHANGE_REASON_MANUAL = 'manual';

@connect(
  state => ({
    channels: state.channels.channelIds.map(item => state.channels.channelsById[item]),
    isLoaded: state.channels.isLoaded,
    isLoading: state.channels.isLoading,
  })
)
@withTranslation(['Offers'], { i18n, wait: !!window })
export default class Channels extends Component {

  static propTypes = {
    channels: PropTypes.array,
    isLoaded: PropTypes.bool,
    isLoading: PropTypes.bool,
    valueToEvent: PropTypes.bool,
    valueParam: PropTypes.string,

    value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onChange: PropTypes.func,

    filter: PropTypes.func,
  };

  static defaultProps = {
    value: '',
    valueParam: 'id',
    onChange: (value, reason) => {},
    filter: () => true
  }

  componentDidMount() {
    this.loadChannels();
    this.selectFirst();
  }

  componentDidUpdate(prevProps) {
    if (((this.props.isLoaded && !prevProps.isLoaded) || this.props.filter !== prevProps.filter) && !this.props.value) {
      this.selectFirst();
    }
  }

  loadChannels() {
    const { isLoaded, isLoading, dispatch } = this.props;

    if(!isLoaded && !isLoading) {
      dispatch(getChannels());
    }

  };

  selectFirst() {
    const { isLoaded, channels, valueParam, filter } = this.props;
    const displayChannels = channels.filter(filter);

    if (isLoaded && displayChannels.length) {
      this.onChange(displayChannels[0][valueParam], CHANNEL_CHANGE_REASON_AUTOSELECT);
    }

  }

  onChange(value, reason) {
    const { onChange, valueToEvent } = this.props;
    if (valueToEvent) {
      onChange({
        target: { value }
      }, reason);
    } else {
      onChange(value, reason);
    }
  }

  render() {
    const { dispatch, channels, isLoaded, isLoading, valueToEvent, value, onChange, filter, valueParam, t, tReady, i18n, ...rest } = this.props;
    const displayChannels = channels.filter(filter);

    if (displayChannels.length <= 1) {
      return false;
    }

    return (
      <TextField
        {...rest}
        select
        label     = {t('exports.channel')}
        fullWidth = {true}
        onChange  = {evt => this.onChange(evt.target.value, CHANNEL_CHANGE_REASON_MANUAL)}
        value     = {value}
        isLoading = {isLoading}
      >
        {displayChannels.map(channel => (
          <MenuItem
            key={channel[valueParam]}
            value={channel[valueParam]}
          >
            {channel.name}
          </MenuItem>
        ))}
      </TextField>
    );
  }

}
